export const setStore = (): void => void 0;
